export default "__VITE_ASSET__Czwmk9nq__"